export default "__VITE_ASSET__156iThnf__"